import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { ProjectChecklistDeletionFormComponent } from '@portal-core/project-checklists/components/project-checklist-deletion-form/project-checklist-deletion-form.component';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';

@NgModule({
  declarations: [ProjectChecklistDeletionFormComponent],
  exports: [
    ProjectChecklistDeletionFormComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule
  ]
})
export class ProjectChecklistDeletionFormModule { }
